import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeBetaCapital';
const args = {};

export class ModeBetaCapital extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
